import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-home-educational-offers',
  templateUrl: './home-educational-offers.component.html',
  styleUrls: ['./home-educational-offers.component.scss']
})
export class HomeEducationalOffersComponent {
  @Input() educationalServices: any[] = [];
}